module.exports = __webpack_public_path__ + "img/retrospect-inspect-medium.ebc95ac0.jpg";